"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var layout_1 = require("./layout");
var SideMenu_1 = require("../../sideMenu/SideMenu");
var PortalPage = /** @class */ (function (_super) {
    __extends(PortalPage, _super);
    function PortalPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PortalPage.prototype.render = function () {
        var subPages = this.props.subPages || [];
        return (React.createElement(layout_1.Page, { id: this.props.id },
            React.createElement(layout_1.Row, { height: "100%" },
                React.createElement(SideMenu_1.default, { currentOption: this.props.page }),
                React.createElement("div", { className: "portal-background" },
                    this.props.isLoading && React.createElement("div", { className: "loading" }),
                    !this.props.hideHeader &&
                        React.createElement("div", { className: "page-title" },
                            React.createElement(layout_1.Margin, { margin: "16px" }),
                            this.props.page,
                            subPages.length > 0 ? ' > ' : '',
                            subPages.join(' > '),
                            React.createElement(layout_1.Margin, { margin: "8px" })),
                    this.props.children))));
    };
    return PortalPage;
}(React.Component));
exports.default = PortalPage;
